import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { emailApi } from "apis/eduidEmail";
import { EduIDButton } from "components/Common/EduIDButton";
import { useAppDispatch } from "eduid-hooks";
import { FormattedMessage } from "react-intl";
import { clearNotifications } from "slices/Notifications";
function DataStatus({ name, verified, primary, handleStartConfirmation, handleMakePrimary, }) {
    if (!verified) {
        return (_jsx(EduIDButton, { buttonstyle: "link sm", onClick: () => handleStartConfirmation(name), children: name === "number" ? (_jsx(FormattedMessage, { id: "dataTable.unverified", defaultMessage: "unverified", description: "unverified" })) : (_jsx(FormattedMessage, { id: "dataTable.button", defaultMessage: "confirm", description: "confirm button" })) }));
    }
    if (primary) {
        return (_jsx("span", { children: _jsx(FormattedMessage, { id: "dataTable.label", defaultMessage: "PRIMARY", description: "primary label" }) }));
    }
    return (_jsx(EduIDButton, { buttonstyle: "link sm", onClick: () => handleMakePrimary(name), children: _jsx(FormattedMessage, { id: "dataTable.makeButton", defaultMessage: "make primary", description: "Make primary button" }) }));
}
function DataTableRows({ data, setSelectedEmail }) {
    const [makePrimaryEmail] = emailApi.useLazyMakePrimaryEmailQuery();
    const [removeEmail] = emailApi.useLazyRemoveEmailQuery();
    const dispatch = useAppDispatch();
    function handleMakePrimary(email) {
        if (email)
            makePrimaryEmail({ email });
    }
    function handleRemove(email) {
        if (email) {
            removeEmail({ email });
        }
    }
    function handleStartConfirmation(email) {
        dispatch(clearNotifications());
        if (email)
            setSelectedEmail(email);
    }
    if (!data) {
        return null;
    }
    const hasUnverifiedEmail = data.some((datum) => datum.email !== undefined && !datum.verified);
    return (_jsx(_Fragment, { children: data.map((datum, i) => {
            var _a, _b, _c;
            const keysArray = Object.keys(datum);
            const valueArray = Object.values(datum);
            const valueName = keysArray[0];
            const value = valueArray[0];
            const email = (_a = datum.email) !== null && _a !== void 0 ? _a : "";
            const disableRemove = datum.primary && hasUnverifiedEmail;
            let valueStatus;
            if (!datum.verified) {
                valueStatus = "unverified";
            }
            else if (datum.primary) {
                valueStatus = "primary";
            }
            else
                valueStatus = "verified";
            return (_jsxs("tr", { className: `${valueName} ${valueStatus}`, "data-identifier": valueName, "data-object": value, children: [_jsx("td", { className: valueStatus, children: value }), _jsx("td", { className: "value-status", children: _jsx(DataStatus, { name: valueName, verified: datum.verified, primary: datum.primary, handleStartConfirmation: () => handleStartConfirmation(email), handleMakePrimary: () => handleMakePrimary(email) }) }), _jsx("td", { className: "remove-data", children: (data && (data === null || data === void 0 ? void 0 : data.length) > 1 && valueName === "email") || valueName === "number" ? (_jsx(EduIDButton, { buttonstyle: "remove sm", disabled: disableRemove, onClick: () => handleRemove(email) })) : null })] }, (_c = (_b = datum.email) !== null && _b !== void 0 ? _b : datum.number) !== null && _c !== void 0 ? _c : i));
        }) }));
}
export function DataTable({ data, setSelectedEmail }) {
    return (_jsx("div", { className: "table-responsive", children: _jsx("table", { className: "table-form", children: _jsxs("tbody", { children: [_jsxs("tr", { className: "display-none", children: [_jsx("th", { children: _jsx(FormattedMessage, { id: "dataTable.name", description: "name", defaultMessage: "name" }) }), _jsx("th", { children: _jsx(FormattedMessage, { id: "dataTable.status", description: "status", defaultMessage: "status" }) }), _jsx("th", { children: _jsx(FormattedMessage, { id: "common.removeText", description: "remove", defaultMessage: "remove" }) })] }), _jsx(DataTableRows, { data: data, setSelectedEmail: setSelectedEmail })] }) }) }));
}
